import React, { Component } from 'react'
import { AjEventsAll } from 'containers/pages'
import { meta } from 'helpers/decorators'

@meta({
  title: 'Adventurous journeys',
  intlKey: 'pageTitle.adventurous_journeys',
  dynamicProp: 'organizations.detail.name'
})
class AwardUnitAjEvents extends Component {
  render() {
    return <AjEventsAll decoFilter="awardUnitEvents" hideNewButton={false} {...this.props} />
  }
}

export default AwardUnitAjEvents
